var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"float-right",attrs:{"variant":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.inserirPleito()}}},[_c('span',[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" Inserir Pleito ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }